<template>
  <div>
    <banner v-if="!hideMyProjects && showBanners" :slides="slides">
      <template v-slot:title="{ title: { index } }">
        <template>
          <h2 class="title">{{ slides[index-1].title.title }}</h2>
        </template>
      </template>
      <template v-slot:description="{ description : { index } }">
        <template>
          <p v-html="slides[index-1].description.text" v-if="(slides[index-1].description.text).includes('<br>')"></p>
          <p v-else>{{ slides[index-1].description.text }}</p>
        </template>
      </template>
      <template v-slot:content="{ content: { index } }">
        <template v-if="index">
          <div class="link-container">
            <button v-if="!!slides[index-1].content.link" @click="openButton1"
                    class="link is-uppercase">
              {{ slides[index-1].content.link.text }}
            </button>
            <button v-if="!!slides[index-1].content.button" @click="openButton2"
                    class="link outline-button padding-right is-uppercase">
              {{ slides[index-1].content.button.text }}
            </button>
            <button v-if="!!slides[index-1].content.button2" @click="openButton3"
                    class="link outline-button padding-right is-uppercase">
              {{ slides[index-1].content.button2.text }}
            </button>
          </div>
        </template>
      </template>
    </banner>
    <modal-learn-more v-if="showLearnModal" @close="closeLearnMore" />
  </div>
</template>

<script>
import ModalLearnMore from '@/components/Modals/LearnMore'
import Banner from './Banner'
import categorySets from '@/mixins/category-set'

import breakpoints from '@/libs/breakpoints'
import ajas from '@/mixins/ajas'
import auth from '@/mixins/auth'
import link from '@/mixins/link'
import utmTracking from '@/mixins/utm-tracking'

export default {
  mixins: [auth, link, ajas, utmTracking, categorySets],
  components: {
    Banner,
    ModalLearnMore
  },
  props: ['landingPage'],
  data: function () {
    return {
      showLearnModal: false,
      slides: [],
      categoryID: 0,
      bannerSetName: '',
      bannerSets: [],
      bannerSetButtons: [],
      isNonCategoryPage: false,
      showBanners: false
    }
  },
  watch: {
    $route () {
      this.isNonCategoryPage = false
      this.getSlides()
    }
  },
  mounted: function () {
    this.getSlides()
  },
  computed: {
    isCustomRoute: function () {
      return !this.category && this.$route.path !== '/home' && this.$route.query.profile !== 'bookmarks' && this.$route.query.profile !== 'contributed'
    },
    isBasicRoute: function () {
      return this.$route.path === '/home' || (this.$route.query.profile && (this.$route.query.profile === 'bookmarks' || this.$route.query.profile === 'contributed'))
    },
    showButton1: function () {
      return !!this.slides[0].content.link.url && (this.slides[0].content.link.url).length > 0
    },
    showButton2: function () {
      return !!this.slides[0].content.button.url && (this.slides[0].content.button.url).length > 0
    },
    showButton3: function () {
      return !!this.slides[0].content.button2.url && (this.slides[0].content.button2.url).length > 0
    },
    enterNow: function () {
      return this.isAfterAjasReleaseDate ? 'submission period ended' : false
    },
    isMobile: function () {
      return breakpoints.isMobile()
    },
    appName: function () {
      return process.env.APP_NAME.toLowerCase()
    },
    getDescription: function () {
      return this.isMobile ? this.slides[0].description.mobileText : this.slides[0].description.text
    },
    hideMyProjects: function () {
      return this.$route.name === 'viewAll' && this.$route.query.profile === 'mine'
    }
  },
  methods: {
    reset: function () {
      this.slides.splice(0)
    },
    checkNonCategoryPage: async function () {
      if (this.$route.path.includes('/discover/colleges')) {
        this.showBanners = true
        this.bannerSetName = this.appName + '-' + this.$route.name + '-' + this.$route.params.discoverpage
        this.bannerSets = await this.getBannerSetForNonCategoryPage(this.bannerSetName)
        this.bannerSetButtons = await this.getBannerButtonsForNonCategoryPage(this.bannerSetName)
      }
    },
    getSlides: async function () {
      const bannerButtons = []
      let catSets = []
      let catBtns = []
      await this.checkNonCategoryPage()
      await this.getCategoryObj()

      if (this.isNonCategoryPage) {
        this.checkNonCategoryPage()
        catSets = this.bannerSets
        catBtns = this.bannerSetButtons
      } else {
        catSets = await this.getCategorySetsForCategoryPage(this.appName, this.categoryID)
        catBtns = await this.getBannerButtonsForCategoryPage(this.appName, this.categoryID)
      }

      if (catBtns) {
        const listOfUserGroups = [...new Set(catBtns.map(it => it.banner_id))]
        listOfUserGroups.forEach(function (aa, index) {
          bannerButtons[index] = catBtns.filter(e => e.banner_id === aa)
        })
      }

      this.reset() // Make sure the slides are clear at this point

      for (let i = 0; i < catSets.length; i++) {
        const emp = {}
        emp.content = {}
        let btn = {}

        emp.id = catSets[i].id
        emp.title = {
          title: catSets[i].title
        }
        emp.background = {
          image: catSets[i].background_image
        }
        emp.logo = {
          image: catSets[i].title_image,
          imageAltText: catSets[i].title_image_alt_text
        }
        emp.description = {
          text: catSets[i].description,
          mobileText: catSets[i].description
        }

        if (bannerButtons[i]) {
          bannerButtons[i].forEach((bb, index) => {
            btn.show = true
            btn.text = bb.text
            btn.url = bb.link
            btn.paramName = bb.option_name
            btn.paramValue = bb.option_value

            if (index === 0) {
              emp.content.link = btn
            } else if (index === 1) {
              emp.content.button = btn
            } else if (index === 2) {
              emp.content.button2 = btn
            }
            btn = {}
          })
        }
        this.slides.push(emp)
      }
    },
    getCategoryObj: async function () {
      if (this.$route.params.category && this.$route.params.category.length > 0) {
        this.category = this.$route.params.category
      } else {
        this.category = this.$route.query.category
      }

      if (this.isCustomRoute) {
        this.isNonCategoryPage = true
      }

      try {
        this.categoryObj = await this.getShowBannerForCategoryFlag(this.category)
        if (this.categoryObj === null) {
          if (this.isBasicRoute) {
            this.showBanners = true
          } else {
            this.showBanners = false
          }
        } else {
          this.categoryID = this.categoryObj.id
          this.showBanners = this.categoryObj.showBanner
        }
      } catch (error) {
        console.error(error)
      }
    },
    openButton1: function () {
      window.open(this.slides[0].content.link.url)
    },
    openButton2: function () {
      window.open(this.slides[0].content.button.url)
    },
    openButton3: function () {
      window.open(this.slides[0].content.button2.url)
    },
    startNow: function () {
      this.$emit('start')
    },
    showSignup: function () {
      this.$store.dispatch('showLoginModal', { source: 'LOGIN:{PATH}' })
    },
    openLearnMore: function () {
      this.showLearnModal = true
      this.$store.dispatch('showLearnMoreModal')
    },
    closeLearnMore: function () {
      this.showLearnModal = false
    }
  }
}
</script>

<style lang="scss" scoped>
  @import '~styles/utils.scss';

  ::v-deep .image-container {
    margin-top: 2rem;
  }

  ::v-deep .text {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    margin: auto 0;
    margin-left: 3%;
    position: relative;
    justify-content: center;
  }

  ::v-deep .title {
    font-weight: 700;
    font-size: 1.2rem !important;  //Important to prevent size from getting overwritten
    line-height: 2em;
    letter-spacing: 0.1rem;
    color: white;
    padding-bottom: .2rem;
    margin-bottom: 0;
    text-align: left;
  }

  ::v-deep .description {
    width: 90%;
    font-size: 1rem;
    line-height: 1.4rem;
    letter-spacing: 0.07rem;
    padding-top: 0.7rem;
    text-align: left;
    position: relative;

    &:before {
      position: absolute;
      content: "";
      height: 2px;
      background-color: $ajas-gold;
      width: 40px;
      top: 0;
      left: 0;
    }
  }

  ::v-deep .link-container {
    display: flex;
    width: 100%;

    button {
      font-weight: 700;
      cursor: pointer;
      border-radius: 0;

      &:focus,
      &:focus-within,
      &:active {
        outline: 0;
      }
    }

    .outline-button {
      background: transparent;
      border: 2px solid $ajas-gold;
      border-radius: 0;
      font-weight: 700;

      &:hover,
      &:focus,
      &:active {
        background: $ajas-gold;
      }
    }

    .padding-right {
      margin-left: 0.7rem;
    }
  }

  ::v-deep .link {
    width: auto;
    font-size: 0.8rem;
    letter-spacing: 0.1rem;
    text-align: center;
    margin-top: 2rem;
    padding: 0.5rem 0.45rem;
    border-radius: 0px;
    border: none;
    background: $ajas-gold;
    color: white;
    font-weight: 700;

    -webkit-box-shadow: 0px 2px 5px 0px rgba(0, 0, 0, 0.5);
    -moz-box-shadow: 0px 2px 5px 0px rgba(0, 0, 0, 0.5);
    box-shadow: 0px 2px 5px 0px rgba(0, 0, 0, 0.5);

    &:hover,
    &:focus,
    &:active {
      background: $ajas-gold;
    }
  }

  @include tablet {
    ::v-deep .title {
      font-size: 2rem;
      padding-bottom: .5rem;
      margin: 0rem 0 0 0;
    }
  }

  @include mobile {
    ::v-deep .image-container {
      margin-top: 1rem;
    }
    .img-logo {
      display: block;
      width: 100%;
      img {
        float: left;
        width: 100%; // 125px;
      }
    }
    ::v-deep .text {
      width: auto;
      margin: auto 5%;

     .title {
       font-size: 1.5rem;
       line-height: 2rem;
       padding-bottom: .5rem;
       padding-left: 0;
       margin: 0;
       width: 100% !important;
       display : inline;
       position:relative;
       text-align: center;
       margin-top: 0.5rem;
     }
    }
    ::v-deep .description {
      width: 100%;
      line-height: 1.3rem;
      font-size: 1rem;
      text-align: center
    }
    ::v-deep .link {
      font-size: 0.85rem;
      margin-top: 1.5rem;
      text-align: center;
      justify-content: center;
    }
    ::v-deep .slide1 {
      background-position: 0;
    }
    ::v-deep .link-container {
      margin-top: 0rem;
      justify-content: center;

      .outline-button {
        padding: 0.5rem;
      }
    }

  }

 @media (max-width: 700px) {
  ::v-deep .description {
    text-align: center;
  }
  ::v-deep .text {
      .title {
        text-align: center;
        margin: 9em 0 0 0;
      }
      p {
        font-size: 0.9rem;
      }
    }
  ::v-deep .link-container {
    text-align: center;
    justify-content: center;
    }
 }

  @media (max-width: 650px) and (min-width: 550px) {
  ::v-deep .text {
      .title {
        margin: 8.5rem 0 0 0;
      }
    }
  }

 @media (max-width: 550px) {
  ::v-deep .text {
      .title {
        margin: 7rem 0 0 0;
      }
    }
 }

  @media (max-width: 400px) {
    .logo {
      border: 2px solid red;
      float:left;
      padding-left: 50rem;
    }
    ::v-deep .text {
      margin-left: 5%;

      .title {
        margin-top: 8rem;
      }
    }
    ::v-deep .link {
      margin-top: 1.5rem;
      display: block;
    }

    ::v-deep .link-container {
      .outline-button {
        padding: 0.5rem;
      }
    }

  }

  @media (max-width: 360px) { // Very small mobile (iPhone 5). mini-mobile wasn't working here.

    ::v-deep .text {
      margin-left: 5%;

      .title {
        margin-top: 8rem;
      }
    }
    ::v-deep .description {
      line-height: 1.2rem;
      font-size: .8rem;
    }

    ::v-deep .link {
      padding: 0.5rem 0.3rem 0.5rem 0.3rem;
      text-align: center;
      justify-content: center;
      margin: 1rem 0 0 0;
    }

    ::v-deep .link-container {
      .outline-button {
        padding: 0.5rem;
      }
    }

  }
  .disabled {
    cursor: not-allowed;
  }
</style>
